import { ArrowRight } from 'lucide-react';
import { formatMapleMarketPrice, mapleMarketHeroBanner, type MapleMarketApp } from '@/data/mapleMarketApps';

interface MapleMarketHeroSectionProps {
  hero?: MapleMarketApp;
  onSelectApp: (appId: string) => void;
}

export default function MapleMarketHeroSection({ hero, onSelectApp }: MapleMarketHeroSectionProps) {
  if (!hero) {
    return null;
  }

  return (
    <section className="relative overflow-hidden rounded-2xl">
      <div className="relative h-[320px] sm:h-[400px] lg:h-[460px]">
        <img
          src={hero.heroImageUrl || mapleMarketHeroBanner}
          alt="Maple Market"
          className="absolute inset-0 h-full w-full object-cover"
          width={1920}
          height={640}
        />
        <div className="absolute left-0 top-0 h-28 w-64 bg-gradient-to-br from-background via-background/95 to-transparent sm:h-32 sm:w-72" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/70 to-transparent" />
        <div className="relative z-10 flex h-full max-w-xl flex-col justify-center px-8 sm:px-12">
          <span className="mb-3 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary">
            <span className="h-1.5 w-1.5 rounded-full gradient-lime" />
            Featured
          </span>
          <h1 className="mb-3 text-3xl font-extrabold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            {hero.name}
          </h1>
          <p className="mb-6 line-clamp-2 text-sm text-muted-foreground sm:text-base">
            {hero.description}
          </p>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => onSelectApp(hero.id)}
              className="inline-flex h-11 items-center gap-2 rounded-lg gradient-lime px-6 text-sm font-semibold text-primary-foreground transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Get it — {formatMapleMarketPrice(hero.price)}
              <ArrowRight className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => onSelectApp(hero.id)}
              className="inline-flex h-11 items-center gap-2 rounded-lg bg-secondary px-6 text-sm font-medium text-secondary-foreground transition-colors hover:bg-accent"
            >
              Learn more
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
